import {crmVi} from "../opportunities";
import {commercialPricingVi} from '../commercialPricing';
import { productionMaterialsVi } from '../productionMaterials';
import { executionVi } from '../productionExecution';
import { qualitySpecsVi } from '../qualitySpecs';
import { productionVi } from '../production';
import { dataExportVi } from '../dataExport';
import { docExportVi } from '../documentExport';
import { sourcingVi } from '../sourcing';
import { mrpVi } from '../mrp';
import { unitPricingVi } from '../unitPricing';
import { soVi } from '../salesOrders';
import { previewVi } from '../featurePreview';
import { binsVi } from '../warehouseBins';
import { requisitionsVi } from '../requisitions';
import { routingsVi } from '../routings';
import { bomsVi } from '../boms';
import { transfersVi } from '../transfers';
import { reservationsVi } from '../reservations';
import { stockCountsVi } from '../stockCounts';
import { subcontractVi } from '../subcontract';
import { ncrVi } from '../ncr';
import { salesIssuesVi } from '../salesIssues';
import { ticketsVi } from '../tickets';
import { claimsVi } from '../claims';
import { supplierClaimsVi } from '../supplierClaims';
import { glVi } from '../gl';
import { kpisVi } from '../kpis';
import { userAccessVi } from '../userAccess';
import { pProcessVi } from '../pProcess';
import { orderProcessVi } from '../orderProcess';
import { portalVi } from '../portal';
import { devicesVi } from '../devices';
import { iqcVi } from "../iqc";
import { warehouseVi } from "../warehouse";
import { releasesVi } from "../releases";
import { settingsWorkspaceVi } from "../settingsWorkspace";
import { userWorkspaceVi } from "../userWorkspace";
import { profitWorkspaceVi } from "../profitWorkspace";
import { statementWorkspaceVi } from "../statementWorkspace";
import { quotationWorkspaceVi } from "../quotationWorkspace";
import { deliveryWorkspaceVi } from "../deliveryWorkspace";
import { packingWorkspaceVi } from "../packingWorkspace";
import { invoiceWorkspaceVi } from "../invoiceWorkspace";
import { piWorkspaceVi } from "../piWorkspace";
import { piPickerVi } from "../piPicker";
import { fxSettingsVi } from "../fxSettings";
import { fxConvertVi } from "../fxConvert";
import { packingBatchVi } from "../packingBatch";
import { evidenceVi } from "../evidence";
import { cardWorkspaceVi } from "../cardWorkspace";
import { sampleWorkspaceVi } from "../sampleWorkspace";
import { poWorkspaceVi } from "../poWorkspace";
import { productListVi } from "../productList";
import { productEditorVi } from "../productEditor";
import { productStockVi } from "../productStock";
import { openingImportVi } from "../openingImport";
import { lotLabelsVi } from "../lotLabels";
import { scanTasksVi } from "../scanTasks";
import { productWorkspaceVi } from "../productWorkspace";
import type { Dict } from "./en";

export const vi: Dict = {
  crm:crmVi,
 commercialPricing: commercialPricingVi,
  unitPricing: unitPricingVi,
  mrp: mrpVi,
  productionMaterials: productionMaterialsVi,
  execution: executionVi,
  qualitySpecs: qualitySpecsVi,
  production: productionVi,
  dataExport: dataExportVi,
  docExport: docExportVi,
  sourcing: sourcingVi,
  transfers: transfersVi,
  reservations: reservationsVi,
  stockCounts: stockCountsVi,
  subcontract: subcontractVi,
  ncr: ncrVi,
  salesIssues: salesIssuesVi,
  tickets: ticketsVi,
  claims: claimsVi,
  supplierClaims: supplierClaimsVi,
  gl: glVi,
  kpis: kpisVi,
  userAccess: userAccessVi,
  pProcess: pProcessVi,
  orderProcess: orderProcessVi,
  portal: portalVi,
  devices: devicesVi,
  boms: bomsVi,
  routings: routingsVi,
  requisitions: requisitionsVi,
  so: soVi,
  preview: previewVi,
  bins: binsVi,
  iqc: iqcVi,
  warehouse: warehouseVi,
  releases: releasesVi,
  settingsWorkspace: settingsWorkspaceVi,
  userWorkspace: userWorkspaceVi,
  profitWorkspace: profitWorkspaceVi,
  statementWorkspace: statementWorkspaceVi,
  quotationWorkspace: quotationWorkspaceVi,
  deliveryWorkspace: deliveryWorkspaceVi,
  packingWorkspace: packingWorkspaceVi,
  invoiceWorkspace: invoiceWorkspaceVi,
  piWorkspace: piWorkspaceVi,
  piPicker: piPickerVi,
  fxSettings: fxSettingsVi,
  fxConvert: fxConvertVi,
  packingBatch: packingBatchVi,
  evidence: evidenceVi,
  companySwitch: {
    vn: "VN",
    cn: "CN",
    label: "Công ty",
    all: "Tất cả công ty",
    hint: "Chỉ xem một công ty — mọi màn, danh sách, báo cáo và sao kê đi theo. Tất cả là xem cả hai, mỗi bản ghi ghi rõ công ty.",
    lockedEditing: "Lưu hoặc huỷ bản ghi đang sửa trước khi đổi công ty.",
  },
  cardWorkspace: cardWorkspaceVi,
  sampleWorkspace: sampleWorkspaceVi,
  poWorkspace: poWorkspaceVi,
  productList: productListVi,
  productEditor: productEditorVi,
  productWorkspace: productWorkspaceVi,
  ...productStockVi,
  ...openingImportVi,
  ...lotLabelsVi,
  ...scanTasksVi,
  brand: { tagline: "Thương mại · ERP" },
  trainingEnv: {
    label: "Môi trường đào tạo",
    detail: "Dữ liệu mẫu — cứ thử thoải mái mọi tính năng, không ảnh hưởng hệ thống thật.",
  },
  piStatus: {
    title: "Tình trạng PI",
    intro: "Hóa đơn chiếu lệ nào đang vướng: thiếu vốn, lẫn đơn vị, đơn mua còn nháp hoặc không khớp. Trang này không có bất kỳ số tiền nào — không doanh thu, không vốn, không lãi, không đơn giá, kể cả trong dữ liệu phía sau.",
    piNo: "Hóa đơn chiếu lệ", customer: "Khách hàng", date: "Ngày", quantity: "Số lượng",
    invoice: "Hóa đơn", invoiced: "Đã xuất hóa đơn", notInvoiced: "Chưa xuất hóa đơn",
    costCoverage: "Mức phủ vốn", needsAttention: "Cần xử lý", noIssue: "Không có vấn đề",
    empty: "Không có hóa đơn chiếu lệ nào trong kỳ này.", error: "Không tải được tình trạng PI.",
    coverage: { po: "Theo đơn mua", mixed: "Nhiều nguồn", catalog: "Theo thẻ sản phẩm", missing: "Chưa đủ" },
    issues: {
      missing_catalog_cost: "Chưa có vốn", invalid_cost: "Vốn không hợp lệ", currency_mismatch: "Lệch tiền tệ",
      unit_mismatch: "Lệch đơn vị", draft_po: "Đơn mua còn nháp", po_charges_excluded: "Chưa tính cước/thuế của đơn mua",
      legacy_cost_baseline: "Vốn lấy theo mốc hệ cũ",
    },
  },
  priceTiers: {
    title: "Bậc giá theo số lượng",
    intro: "Giá bán theo số lượng đặt, chung cho mọi khách. Chỉ nhập mốc số lượng bắt đầu của từng bậc — bậc sau tự khép bậc trước. Giá riêng đã thỏa thuận với khách vẫn thắng các bậc này, và giá dưới MOQ là chuyện riêng.",
    fromQuantity: "Từ số lượng", price: "Đơn giá ({{currency}})", range: "{{from}} – {{to}}", andUp: "trở lên",
    add: "Thêm bậc", hintTier: "bậc từ {{from}}", hintUnderMoq: "giá dưới MOQ", hintCustomer: "giá riêng của khách", hintApply: "Bấm để dùng giá này", empty: "Chưa có bậc nào — dùng giá bán trên thẻ sản phẩm.",
    invalid: "Nhập mốc số lượng nguyên từ 1 trở lên và đơn giá hợp lệ.",
    duplicate: "Hai bậc không được bắt đầu ở cùng một mốc số lượng.",
    error: "Không tải hoặc lưu được bậc giá.",
  },
  mail: {
    title: "Gửi qua email", from: "Gửi từ", to: "Gửi tới", toPlaceholder: "khachhang@example.com",
    subjectLabel: "Tiêu đề", body: "Nội dung", send: "Gửi", noMailbox: "Chưa cấu hình hòm thư",
    notConfigured: "Chưa cấu hình hòm thư gửi đi nên chưa gửi được. Thư nháp bên dưới đã sẵn sàng — khai báo hòm thư là gửi được ngay từ đây.",
    error: "Không gửi được thư.",
    greeting: "Kính gửi {{customer}},", closing: "Trân trọng,",
    subject: { pi: "Hóa đơn chiếu lệ {{documentNo}}", sampleOrder: "Đơn hàng mẫu {{documentNo}}" },
    intro: { pi: "Kính gửi quý khách thông tin hóa đơn chiếu lệ {{documentNo}} như sau.", sampleOrder: "Kính gửi quý khách thông tin đơn hàng mẫu {{documentNo}} như sau." },
    line: { date: "Ngày: {{date}}", customerPo: "Đơn đặt hàng của quý khách: {{po}}", products: "Mặt hàng: {{codes}}" },
  },
  productFiles: {
    title: "Tệp của sản phẩm (chỉ quản trị viên)",
    intro: "Bản vẽ, PDF kỹ thuật, tài liệu Office và tệp nén, tối đa {{max}} mỗi tệp. Tệp lớn được cắt ngay tại trình duyệt và gửi thành nhiều phần qua chính trang này, nên bản vẽ CAD vẫn tải lên được bằng đường mạng thường. Chỉ quản trị viên tải lên và tải về — ảnh danh mục và ảnh duyệt mẫu không đổi.",
    choose: "Chọn tệp", uploading: "Đang tải lên…", empty: "Chưa có tệp nào.",
    progress: "{{name}} · phần {{done}}/{{total}}",
    error: "Không tải được, tải lên hoặc xóa tệp.",
    reject: { empty_name: "Tệp không có tên.", too_large: "Tệp phải từ {{max}} trở xuống.", blocked_type: "Không nhận tệp chạy được khi mở (exe, js, html, svg…)." },
  },
  nav: {
    opportunities: "Cơ hội bán hàng",
    sourcing: "Yêu cầu báo giá (RFQ)",
    mrp: "Hoạch định nguyên liệu (MRP)",
    unitPricing: "Đơn vị & bảng giá",
    pendingReview: "Chờ khách xác nhận",
    walkthroughDone: "Đã rà cùng anh Toàn {{date}}",
    overview: "Tổng quan & Báo cáo",
    dashboard: "Bảng điều khiển",
    analytics: "Phân tích bán hàng",
    profit: "Tổng hợp lợi nhuận",
    piStatus: "Tình trạng PI",
    kpis: "Chỉ số vận hành (KPI)",
    orderProcess: "Quy trình thường",
    pProcess: "Quy trình P",
    portal: "Cổng nhà cung cấp",
    devices: "Quét & tem",
    masterData: "Danh mục",
    products: "Sản phẩm",
    customers: "Khách hàng",
    suppliers: "Nhà cung cấp",
    sales: "Bán hàng",
    proformaInvoices: "Hóa đơn chiếu lệ (PI)",
    invoices: "Hóa đơn",
    quotations: "Báo giá",
    packingLists: "Phiếu đóng gói",
    deliveryNotes: "Phiếu giao hàng",
    statement: "Bảng kê công nợ",
    procurement: "Mua hàng",
    purchaseOrders: "Đơn mua hàng",
    supplierClaims: "Khiếu nại nhà cung cấp",
    samples: "Quản lý mẫu",
    sampleOrders: "Đơn hàng mẫu",
    sampleCards: "Thẻ mẫu",
    erp: "Phân hệ ERP",
    warehouse: "Kho & LOT",
    warehouseLocations: "Vị trí kho",
    production: "Sản xuất",
    quality: "Chất lượng",
    finance: "Bút toán kế toán",
    admin: "Quản trị hệ thống",
    settings: "Cài đặt",
    users: "Quản lý người dùng",
    deletedRecords: "Bản ghi đã xóa",
    routings: "Quy trình công đoạn",
    boms: "Định mức vật tư (BOM)",
    salesOrders: "Đơn bán hàng",
    requisitions: "Yêu cầu mua hàng",
    stockMoves: "Biến động kho",
    glAccounts: "Hệ thống tài khoản",
    serviceTickets: "Hậu mãi",
    inventoryDelivery: "Kho & Giao hàng",
    manufacturingQuality: "Sản xuất & Chất lượng",
    financeReceivables: "Tài chính & Công nợ",
    inDevelopment: "Đang phát triển",
    inProgress: "Đang làm",
  },
  common: {
    internalReference: "Đơn nội bộ",
    internalReferenceHint: "Chứng từ của khách bạn không được xem — kho và sản xuất vẫn làm việc với đơn này, chỉ không hiện số và tên khách.",
    internalSupplier: "Nhà cung cấp nội bộ",
    internalSupplierHint: "Nhà cung cấp riêng tư bạn không được xem — chứng từ vẫn hiện để kho làm việc, nhưng chỉ quản trị viên và người theo dõi nhà cung cấp đó thấy tên và sửa được.",
    printLanguage: "Bản in dùng",
    printLanguage_en: "Tiếng Anh",
    printLanguage_zh: "Tiếng Hoa",
    labelLanguage: "Ngôn ngữ trên tem",
    labelLanguage_en: "Tiếng Anh",
    labelLanguage_zh: "Tiếng Hoa",
    labelLanguage_both: "Anh + Hoa",
    labelLanguageHint: "Chọn lúc in, áp cho mọi tem đang in. Lựa chọn được nhớ trên máy này.",
    descriptionLangHint: "Cột mô tả bên dưới đang sửa bản {{lang}}. Đổi nút phía trên để sửa và in bản còn lại.",
    rowNumber: "STT",
    search: "Tìm kiếm",
    typeToSearch: "Gõ vài chữ để tìm…",
    searchPlaceholder: "Tìm chứng từ, khách hàng, sản phẩm…",
    new: "Tạo mới",
    create: "Tạo",
    export: "Xuất",
    print: "In",
    filter: "Lọc",
    all: "Tất cả",
    cancel: "Hủy",
    continue: "Tiếp tục",
    close: "Đóng",
    save: "Lưu",
    edit: "Sửa",
    actions: "Thao tác",
    language: "Ngôn ngữ",
    webVersion: "v{{version}}",
    signOut: "Đăng xuất",
    viewAll: "Xem tất cả",
    noDocuments: "Chưa có chứng từ.",
    documentsError: "Không tải được chứng từ.",
    removeFilter: "Bỏ lọc",
    soon: "Sắp ra mắt",
    loading: "Đang tải…",
    /** Mảnh cuối của thanh đường dẫn khi chứng từ không mở được (ngoài phạm vi, đã xoá, lỗi mạng) — thay "Đang tải…". */
    unavailable: "Không mở được",
    savedShort: "Đã lưu",
    saving: "Đang lưu…",
    creating: "Đang tạo…",
    uploading: "Đang tải lên…",
    retry: "Thử lại",
    delete: "Xóa",
    confirmArchive: "Bản ghi sẽ được lưu trữ và có thể khôi phục sau.",
    refresh: "Làm mới",
    remove: "Gỡ",
    restore: "Khôi phục",
    add: "Thêm",
    addLine: "Thêm dòng",
    removeLine: "Xóa dòng",
    removeContact: "Xóa liên hệ",
    deletePayment: "Xóa thanh toán",
    noMatches: "Không có kết quả",
    editMode: "Chỉnh sửa",
    createMode: "Tạo mới",
    saved: "Đã lưu.",
    unsavedTitle: "Bỏ các thay đổi chưa lưu?",
    unsavedDescription: "Các thay đổi chưa được lưu. Nếu đóng bây giờ, chúng sẽ bị mất.",
    keepEditing: "Tiếp tục chỉnh sửa",
    discardChanges: "Bỏ thay đổi",
    openNavigation: "Mở điều hướng",
    closeNavigation: "Đóng điều hướng",
    toggleSidebar: "Thu gọn hoặc mở rộng thanh bên",
    primaryNavigation: "Điều hướng chính",
    breadcrumb: "Đường dẫn trang",
    name: "Tên",
    email: "Email",
    password: "Mật khẩu",
    role: "Vai trò",
    status: "Trạng thái",
    date: "Ngày",
    type: "Loại",
    total: "Tổng",
    product: "Sản phẩm",
    customer: "Khách hàng",
    supplier: "Nhà cung cấp",
    items: "Mặt hàng",
    remarks: "Ghi chú",
    code: "Mã",
    description: "Mô tả",
    color: "Màu",
    size: "Kích cỡ",
    colorSize: "Màu / Kích cỡ",
    quantity: "Số lượng",
    qty: "Số lượng",
    unitPrice: "Đơn giá",
    amount: "Thành tiền",
    subtotal: "Cộng tiền hàng",
    delivery: "Giao hàng",
    shipping: "Vận chuyển",
    method: "Phương thức",
    address: "Địa chỉ",
    phone: "Điện thoại",
    taxId: "Mã số thuế",
    reference: "Tham chiếu",
    fromPi: "Từ PI",
    shipTo: "Giao đến",
    cartons: "Thùng",
    when: "Thời điểm",
    age: "Tuổi nợ",
    version: "Phiên bản",
    location: "Vị trí",
    result: "Kết quả",
    rejected: "Từ chối",
    planned: "Kế hoạch",
    produced: "Đã sản xuất",
    priority: "Ưu tiên",
    subject: "Tiêu đề",
    lastLogin: "Đăng nhập gần nhất",
    originalId: "ID gốc",
    deletedBy: "Người xóa",
    currency: "Tiền tệ",
    created: "Tạo / Bởi",
    createdOn: "Ngày tạo",
    yes: "Có",
    no: "Không",
    createdBy: "Người tạo",
    createdDate: "Ngày tạo",
    invalidField: "Giá trị không hợp lệ: {{field}}",
    lineError: "Dòng {{line}}: {{field}} không hợp lệ",
    subRef: "Mã phụ",
    customerStyleNo: "Mã mẫu khách hàng",
    unit: "Đơn vị",
    moq: "MOQ",
    mcq: "MCQ",
    msq: "MSQ",
    dtdPrice: "Giá DTD",
    exwPrice: "Giá EXW",
    underMoqPrice: "Giá dưới MOQ",
    sampleLeadTime: "L/T mẫu",
    bulkLeadTime: "L/T sản xuất",
    image: "Hình ảnh",
    lineRemark: "Ghi chú dòng",
    currencyLabel: "Tiền tệ",
  },
  pagination: {
    label: "Phân trang",
    range: "{{from}}–{{to}} trên {{total}}",
    rowsPerPage: "Số dòng",
    pageOf: "Trang {{page}} / {{pages}}",
    first: "Trang đầu",
    previous: "Trang trước",
    next: "Trang sau",
    last: "Trang cuối",
    goToPage: "Đi đến trang",
  },
  login: {
    supplierHint: "Dùng mã và mật khẩu do Hisense cấp.",
    title: "Đăng nhập",
    brandLogoAlt: "Logo Hisense Button",
    subtitle: "Hisense Button · Hệ thống quản trị",
    heroEyebrow: "Thương mại & ERP sản xuất",
    heroTitle: "Một nền tảng thống nhất, từ kinh doanh đến sản xuất.",
    heroDescription:
      "Hợp nhất bán hàng, chứng từ, quản lý mẫu và vận hành nhà máy trên một hệ thống đa ngôn ngữ, hỗ trợ kết nối giữa Việt Nam và Trung Quốc.",
    heroModules: "8 phân hệ ERP",
    heroLanguages: "VI · EN · 中文",
    heroCloud: "Kết nối Việt Nam – Trung Quốc",
    builtBy: "Giải pháp được phát triển bởi ToanKhonTech",
    email: "Email",
    emailPlaceholder: "email@hisensebutton.com",
    audienceLabel: "Chọn cổng đăng nhập",
    audienceStaff: "Nhân viên Hisense",
    audienceSupplier: "Nhà cung cấp",
    supplierId: "Mã nhà cung cấp",
    supplierIdPlaceholder: "NCC-XXXXXX",
    staffHint: "Đăng nhập bằng email nhân viên Hisense.",
    wrongTabStaff: "Chuỗi này trông như mã nhà cung cấp. Thử thẻ “Nhà cung cấp” ở trên.",
    wrongTabSupplier: "Chuỗi này trông như địa chỉ email. Thử thẻ “Nhân viên Hisense” ở trên.",
    password: "Mật khẩu",
    showPassword: "Hiện mật khẩu",
    hidePassword: "Ẩn mật khẩu",
    remember: "Ghi nhớ đăng nhập",
    submit: "Đăng nhập",
    submitting: "Đang đăng nhập…",
    demoLabel: "Tài khoản demo",
    errorInvalidCredentials: "Email hoặc mật khẩu không chính xác.",
    errorAccountDisabled: "Tài khoản này đã bị vô hiệu hóa. Vui lòng liên hệ quản trị viên.",
    errorGeneric: "Đăng nhập không thành công. Vui lòng thử lại.",
  },
  dashboard: {
    activity: {
      pi_created: "vừa lập proforma invoice · {{amount}}",
      invoice_created: "vừa lập hoá đơn · {{amount}}",
      quotation_created: "vừa lập báo giá",
      po_created: "vừa lập đơn mua hàng · {{amount}}",
    },
    title: "Bảng điều khiển",
    subtitle: "Tổng quan vận hành",
    revenueMTD: "Doanh thu · Tháng này",
    openPis: "PI đang mở",
    arOutstanding: "Công nợ phải thu",
    arOverdue: "quá hạn",
    samples: "Mẫu đang xử lý",
    noReorderPoint: "Chưa đặt ngưỡng đặt lại hàng cho {{count}} sản phẩm",
    inventory: {
      title: "Kho cần xử lý",
      since: "(tính từ {{since}}, ngày ghi sổ tồn đầu kỳ đầu tiên)",
      deliveredNotIssued: "phiếu giao đã rời kho nhưng chưa ghi nguồn hàng, hoặc khách nhận nhiều hơn số đã xuất",
      invoicesFromStock: "hoá đơn bán mã đang có tồn nhưng chưa có phiếu giao ghi nguồn hàng",
      receivedNotStocked: "đơn mua báo đã về nhưng chưa nhập kho đủ",
      directWithStock: "giao thẳng trong lúc kho có hàng mã đó — chờ người Duyệt xem lại",
      clear: "Kho: không có việc tồn đọng (tính từ {{since}}).",
      notStarted: "Chưa bắt đầu quản lý tồn theo lô: chưa ghi sổ phiếu tồn đầu kỳ nào.",
      openCounts: "Nhập tồn đầu kỳ",
    },
    activity7d: "Chứng từ đã lập · 7 ngày gần nhất",
    work: {
      unpaidPis: "PI chưa thu đủ",
      expiredPis: "PI quá hạn hiệu lực",
      openPos: "đơn mua chưa nhận đủ",
      openQuotations: "báo giá đang lưu",
    },
    lowStock: "Sản phẩm sắp hết hàng",
    recentActivity: "Hoạt động gần đây",
    arAging: "Tuổi nợ công nợ",
    topCustomers: "Khách hàng · Công nợ mở",
    awaiting: "chờ thu",
    changeVsLastMonth: "{{value}}% so với tháng trước",
    noPrevMonth: "Tháng trước chưa có doanh thu để so",
    currencyExcluded: "Chưa gồm {{count}} chứng từ bằng {{currency}}",
    errorLoad: "Không thể tải bảng điều khiển.",
    paymentActivity: "đã ghi nhận thanh toán {{method}} trị giá {{amount}}",
    paymentMethod: "thanh toán",
  },
  customers: {
    /** Dấu nối tên người theo đơn — tiếng Hoa dùng "、". */
    followersSeparator: ", ",
    followersLine: "Người theo đơn: {{names}}",
    /** Khách riêng tư / liên hệ riêng tư (Roary 30/09/2026) — chỉ quản trị viên thấy và đặt được. */
    private: "Khách riêng tư",
    privateHint: "Chỉ quản trị viên thấy khách này và mọi chứng từ của khách (báo giá, PI, hoá đơn, packing list, phiếu giao hàng, đơn mẫu, sao kê, báo cáo). Người theo đơn, kế toán, kho cũng không thấy.",
    followersPrivate: "Khách riêng tư: người theo đơn không phải quản trị viên sẽ không thấy khách này.",
    privateBadge: "Riêng tư",
    contactPrivate: "Chỉ quản trị viên xem",
    contactPrivateToggle: "Chỉ quản trị viên xem · người liên hệ {{n}}",
    contactsPrivateHint: "Bấm biểu tượng khoá ở cột tên để chỉ quản trị viên thấy người liên hệ đó (ví dụ sếp của khách). Người khác không thấy người đó ở hồ sơ, tìm kiếm và ô chọn người nhận; họ lưu hồ sơ khách cũng không làm mất người đó.",
    privateContactSuffix: " (chỉ quản trị viên)",
    followerAdd: "Thêm người theo đơn…",
    followerRemove: "Bỏ {{name}}",
    followerOptionsError: "Không tải được danh sách nhân viên.",
    followerUnreachable: "{{names}}: không thấy được khách này (khác khu vực hoặc tài khoản đã khoá) — nên bỏ ra.",
    followerSelfLocked: "Bạn chỉ xem khách mình theo đơn nên tên bạn luôn ở đây.",
    followersHint: "Chọn được nhiều người. Tài khoản \"Chỉ khách mình theo đơn\" chỉ thấy khách có tên mình ở đây.",
    followersNone: "Chưa có người theo đơn — chỉ quản trị viên và tài khoản xem tất cả khách thấy khách này.",
    followerDisabled: "đã khoá",
    filterNoFollower: "Chưa có người theo đơn",
    code: "Mã khách / Tên viết tắt",
    codeHint: "Mã nội bộ, không trùng. Không bắt buộc.",
    codeTaken: "Mã này đã có khách khác dùng.",
    filterPrivate: "Khách riêng tư",
    filterPrivateHint: "Chỉ hiện khách riêng tư (chỉ quản trị viên thấy). Dùng chung được với Việt Nam / Trung Quốc — khách riêng tư vẫn thuộc đúng công ty của nó.",
    editCustomer: "Chỉnh sửa khách hàng",
    editNamed: "Chỉnh sửa khách hàng: {{name}}",
    backToList: "Về danh sách khách hàng",
    required: "Bắt buộc",
    sectionSales: "Thiết lập bán hàng",
    moreContacts: "+{{count}} người liên hệ khác",
    errorDelete: "Không thể xóa khách hàng.",
    notFound: "Không tìm thấy khách hàng.",
    title: "Khách hàng",
    subtitle: "Dữ liệu gốc · tài khoản & liên hệ",
    company: "Công ty",
    classification: "Phân loại",
    vietnam: "Việt Nam",
    china: "Trung Quốc",
    classificationLocked: "Cố định theo khu vực dữ liệu của tài khoản bạn.",
    cs: "Người theo đơn",
    terms: "Điều khoản thanh toán",
    contacts: "Liên hệ",
    contactCount: "Số người liên hệ",
    openAr: "Công nợ mở",
    newCustomer: "Khách hàng mới",
    loading: "Đang tải khách hàng…",
    errorLoad: "Không thể tải danh sách khách hàng.",
    errorSave: "Không thể lưu khách hàng.",
    confirmDeleteNamed: "Xóa {{name}}? Bản ghi sẽ được lưu trữ.",
    addContact: "Thêm liên hệ",
    contactName: "Tên liên hệ",
    contactPersonN: "Liên hệ {{n}}",
    phone1: "Điện thoại 1",
    phone2: "Điện thoại 2",
    wechat: "WeChat ID",
    section: "Bộ phận / Phòng ban",
    brandName: "Thương hiệu",
    team: "Nhóm",
    contactsCountHint: "{{count}}/{{max}} liên hệ · mỗi liên hệ phải có tên",
    errorContactName: "Liên hệ {{n}}: bắt buộc nhập tên.",
    selectTerm: "Chọn điều khoản thanh toán",
    unassigned: "Chưa phân công",
    sectionCompany: "Thông tin công ty",
    sectionContacts: "Người liên hệ",
    companyHint: "Tên, địa chỉ và điện thoại in trên chứng từ.",
    salesHint: "Điều khoản thanh toán, phân loại, người theo đơn và mặc định P-Process cho PI mới.",
    saveHint: "Hàng liên hệ để trống hoàn toàn sẽ được bỏ khi lưu.",
    sideShow: "Hiện cột phụ",
    sideHide: "Ẩn cột phụ",
    sideColumns: "Điện thoại 2, thương hiệu, WeChat ID, nhóm",
    sideLocked: "Có người liên hệ đang dùng cột phụ nên cột phụ luôn hiện.",
    piRef: "PI {{no}}",
    documents: "Chứng từ gần đây",
    documentsHint: "5 chứng từ mới nhất mỗi loại. Bấm Xem tất cả để mở danh sách đã lọc theo khách này.",
    itemCount: "{{count}} mặt hàng",
    noContacts: "Chưa có liên hệ",
    openCustomer: "Mở khách hàng",
  },
  lot: {
    pProcessDefaultOff: "Tắt cho PI mới",
    pProcessDefaultOn: "Bật cho PI mới",
    number: "Số LOT",
    placeholder: "số lô của nhà cung cấp",
    pProcess: "P-Process",
    pProcessHint: "Theo dõi số lô trên mọi chứng từ của đơn này",
    pProcessDefault: "Mặc định bật P-Process",
    pProcessDefaultHint: "Đặt P-Process mặc định cho PI mới. Chứng từ đã tạo giữ nguyên thiết lập riêng. Số LOT được nhập theo từng dòng hàng, sử dụng số lô của nhà cung cấp.",
  },
  products: {
    title: "Sản phẩm",
    refs: "Mã phụ / khách hàng",
    typeBrand: "Loại / Thương hiệu",
    wireSize: "Kích thước dây",
    weightPer100: "Nặng/100",
    lowestPrice: "Giá sàn",
    upCharge: "Phụ thu",
    leadTime: "Lead time M/SL",
    orderQty: "MOQ / MCQ·MSQ",
    storageLocation: "Kho / Vị trí",
    currency: "Tiền tệ",
    created: "Tạo / Bởi",
    subtitle: "Dữ liệu gốc · danh mục & giá",
    searchPlaceholder: "Tìm mã, mô tả, ref, thương hiệu, màu…",
    allTypes: "Mọi loại",
    allBrands: "Mọi thương hiệu",
    allApprovals: "Mọi phê duyệt",
    allSuppliers: "Mọi nhà cung cấp",
    filterSearch: "Lọc danh sách…",
    code: "Mã",
    description: "Mô tả",
    descriptionEn: "Mô tả tiếng Anh",
    descriptionZh: "Mô tả tiếng Hoa",
    descriptionPrimary: "Là bản chính",
    descriptionHint: "Bản chính được chép sẵn vào dòng hàng và in lên tem. Bản in của từng chứng từ chọn riêng ở chính chứng từ đó, vì cùng một mã hàng có thể bán cho khách dùng hai thứ tiếng khác nhau. Ô nào bỏ trống thì hệ dùng ô còn lại chứ không in trống.",
    type: "Loại",
    selectType: "Chọn loại sản phẩm",
    legacyType: "giá trị cũ hiện tại",
    brand: "Thương hiệu",
    color: "Màu",
    size: "Kích cỡ",
    colorZh: "Màu (tiếng Hoa)",
    materialType: "Loại vật liệu",
    materialTypeHint: "VD: Đồng thau, Inox 304, Hợp kim kẽm",
    materialWidth: "Chiều rộng vật liệu",
    materialThickness: "Độ dày",
    materialHardness: "Độ cứng / Trạng thái tôi",
    materialHardnessHint: "VD: H14, 1/2H, HV 150",
    unit: "Đơn vị",
    selectUnit: "Chọn đơn vị sản phẩm",
    legacyUnit: "giá trị cũ hiện tại",
    moq: "MOQ",
    stock: "Tồn kho",
    approval: "Phê duyệt",
    sellingPrice: "Giá bán",
    sellingPriceHint: "Giá niêm yết mặc định · {{currency}}",
    costPrice: "Giá vốn",
    supplier: "Nhà cung cấp",
    supplierAndRef: "Nhà cung cấp / Mã tham chiếu",
    newSampleOrderFrom: "Tạo đơn mẫu từ sản phẩm này",
    newSampleCardFrom: "Tạo phiếu mẫu từ sản phẩm này",
    advancedFilters: "Bộ lọc nâng cao",
    clearFilters: "Xoá bộ lọc",
    minPrice: "Giá bán từ",
    maxPrice: "Giá bán đến",
    minStock: "Tồn kho từ",
    maxStock: "Tồn kho đến",
    createdFrom: "Tạo từ ngày",
    createdTo: "Tạo đến ngày",
    rangeReversed: "Giá trị đầu đang lớn hơn giá trị cuối — không có dòng nào khớp.",
    newProduct: "Sản phẩm mới",
    codeHint: "để trống = tự đánh số",
    image: "Hình ảnh",
    imagePreview: "Hình ảnh sản phẩm",
    viewImage: "Xem hình ảnh",
    uploadImage: "Tải ảnh lên",
    removeImage: "Xóa ảnh",
    imageDropHint: "Kéo thả hoặc dán ảnh",
    imageDropTitle: "Bấm để chọn ảnh, kéo ảnh thả vào đây, hoặc nhấn {{shortcut}} để dán ảnh vừa copy (ví dụ từ WeChat).",
    imageDropNoFile: "Không nhận được tệp ảnh. Copy ảnh (ví dụ trong WeChat) rồi nhấn {{shortcut}} ở đây, hoặc lưu ảnh ra máy rồi bấm Tải ảnh lên.",
    invalidNumber: "Số không hợp lệ ở",
    confirmDelete: "Xóa sản phẩm này? Sẽ được lưu trữ và có thể khôi phục sau.",
    loading: "Đang tải sản phẩm…",
    errorLoad: "Không thể tải danh sách sản phẩm.",
    errorSave: "Không thể lưu sản phẩm.",
    imageTooLarge: "Ảnh phải từ 5MB trở xuống (tính sau khi nén).",
    imageBadType: "Chỉ nhận ảnh PNG, JPEG, WEBP hoặc GIF.",
    legacyNegative: "Dữ liệu cũ: {{fields}} đang mang giá trị âm, form không nhận. Hãy sửa lại hoặc xoá trống các ô đó trước khi lưu.",
    errorUpload: "Tải hình ảnh lên không thành công.",
    subRef: "Mã phụ",
    subRefHint: "Mã biến thể tùy chọn (màu, cỡ…)",
    customerRef: "Mã khách hàng",
    supplierProductRef: "Mã sản phẩm của nhà cung cấp",
    selectSupplier: "Chọn nhà cung cấp",
    currencyLabel: "Tiền tệ",
    lowestPriceHint: "Giá bán thấp nhất chấp nhận được",
    sampleLeadTime: "Lead time mẫu (ngày)",
    bulkLeadTime: "Lead time sản xuất (ngày)",
    moqHint: "Tổng số lượng đặt tối thiểu",
    mcq: "MCQ",
    mcqHint: "Số lượng tối thiểu mỗi màu",
    msq: "MSQ",
    msqHint: "Số lượng tối thiểu mỗi cỡ",
    storage: "Kho",
    moldRef: "Mã khuôn",
    moldLocation: "Nơi cất khuôn",
    wire: {
      length: "Chiều dài",
      width: "Chiều rộng",
      height: "Chiều cao",
      innerWidth: "Rộng lòng trong",
      diameter: "Đường kính",
      wireDiameter: "Đường kính dây",
    },
    reorderPoint: "Ngưỡng đặt lại hàng",
    reorderPointHint: "Cảnh báo khi tồn kho xuống dưới mức này. Để trống là không cảnh báo — đây không phải MOQ.",
    storageHint: "Loại kho / điều kiện bảo quản",
    weightUnit: "Đơn vị khối lượng",
    wireLength: "Chiều dài",
    wireWidth: "Chiều rộng",
    wireHeight: "Chiều cao",
    wireInnerWidth: "Rộng trong",
    wireDiameter: "Đường kính",
    wireWireDiameter: "Đường kính dây",
    approvalProof: "Chứng từ phê duyệt",
    approvalProofHint: "Thư duyệt, email hoặc chứng nhận (tùy chọn)",
    uploadApprovalProof: "Tải chứng từ lên",
    removeApprovalProof: "Xóa chứng từ",
    keepOpenNextCode: "Giữ form mở với mã kế tiếp sau khi lưu",
    sectionBasic: "Thông tin cơ bản",
    sectionSpecs: "Thông số kỹ thuật",
    sectionSupplier: "Nhà cung cấp",
    sectionPricing: "Giá & lead time",
    sectionStatus: "Trạng thái & tồn kho",
    filterType: "Tất cả loại",
    openProduct: "Xem chi tiết sản phẩm",
    notFound: "Không tìm thấy sản phẩm.",
    errorDelete: "Không thể xóa sản phẩm này.",
  },
  pricing: {
    title: "Giá theo khách",
    hint: "Giá này ghi đè giá bán với một khách. Khách khác dùng giá bán phía trên.",
    customer: "Khách hàng",
    selectCustomer: "Chọn khách hàng",
    scope: "Áp dụng cho",
    listPrice: "Giá niêm yết",
    price: "Giá",
    setPrice: "Ghi giá khách",
    effective: "Hiệu lực",
    status: "Trạng thái",
    current: "Hiện hành",
    closed: "Đã đóng",
    none: "Chưa có giá riêng. Chứng từ dùng giá bán phía trên.",
    afterSave: "Lưu sản phẩm trước, rồi mở lại để thêm giá theo khách.",
    invalidPrice: "Nhập giá hợp lệ",
    errorSet: "Không thể thiết lập giá.",
    loading: "Đang tải bảng giá…",
  },
  quotations: {
    no: "Số báo giá",
    new: "Báo giá mới",
    preparedBy: "Người lập",
    lines: "Dòng",
    subtitle: "Báo giá độc lập",
    document: "Báo giá",
    to: "Gửi đến",
    attn: "Người nhận",
    errorLoad: "Không thể tải danh sách báo giá.",
    errorSave: "Không thể lưu báo giá.",
    confirmDelete: "Xóa báo giá {{number}}?",
    printingDate: "Ngày in",
    billToText: "Bên mua (nhập tay)",
    billToTextHint: "Chép từ hệ thống cũ; chọn khách hàng ở ô phía trên.",
    unknownCustomer: "Khách hàng không xác định (ẩn khi in)",
    addProduct: "Thêm sản phẩm",
    duplicateProduct: "Sản phẩm này đã có trong báo giá.",
  },
  samples: {
    courier: "Hãng vận chuyển",
    trackingNo: "Số vận đơn",
    shippedAt: "Ngày gửi",
    newOrder: "Đơn hàng mẫu mới",
    newCard: "Thẻ mẫu mới",
    orderType: "Loại đơn",
    team: "Bộ phận",
    labTest: "Yêu cầu kiểm nghiệm",
    ordersSubtitle: "Phát triển mẫu · kiểm nghiệm",
    cardsSubtitle: "Thẻ mẫu tham chiếu",
    fromSupplier: "Từ nhà cung cấp",
    toCustomer: "Đến khách hàng",
    productNo: "Mã sản phẩm",
    requestedShort: "YC",
    retainedShort: "Lưu",
    orderNo: "Số đơn mẫu",
    party: "Đối tác",
    cardNo: "Số thẻ",
    errorOrders: "Không thể tải danh sách đơn hàng mẫu.",
    errorCards: "Không thể tải danh sách thẻ mẫu.",
    errorCreateOrder: "Không thể tạo đơn hàng mẫu.",
    errorCreateCard: "Không thể tạo thẻ mẫu.",
    errorUpload: "Tải ảnh lên thất bại.",
    orderDelivery: "Ngày đặt / Giao",
    attachments: "Đính kèm",
    firstProduct: "Sản phẩm",
    andMore: "+{{count}} dòng nữa",
    contactEmail: "Email liên hệ",
    contactHint: "Được chốt khi lập đơn, để in lại vẫn khớp bản đã gửi đi.",
    controlSample: "Mẫu đối",
    productDesc: "Sản phẩm / Mô tả",
    orderDate: "Ngày đặt",
    deliveryDate: "Ngày giao",
    editOrder: "Sửa đơn hàng mẫu",
    editCard: "Sửa thẻ mẫu",
    selectSupplier: "Tìm và chọn nhà cung cấp",
    selectCustomer: "Tìm và chọn khách hàng",
    contactPerson: "Người liên hệ",
    selectContact: "Chọn người liên hệ",
    addProduct: "Thêm sản phẩm",
    manualEntry: "Nhập thủ công",
    manualBadge: "Thủ công",
    searchProducts: "Tìm theo mã, mô tả, loại hoặc thương hiệu…",
    duplicateProduct: "Sản phẩm này đã có trong đơn.",
    subRef: "Mã phụ",
    requestQuantity: "Số lượng yêu cầu",
    retainedQuantity: "Số lượng lưu mẫu",
    controlSampleNotes: "Ghi chú mẫu đối",
    useProductImage: "Dùng ảnh sản phẩm",
    noItems: "Chưa có sản phẩm nào",
    noItemsHint: "Dùng “Thêm sản phẩm” để chọn từ danh mục, hoặc “Nhập thủ công” cho sản phẩm chưa có.",
    addFiles: "Thêm tệp",
    noAttachments: "Chưa có tệp đính kèm",
    attachmentHint: "Ảnh (JPG, PNG, WebP — tối đa 5 MB) hoặc tài liệu (PDF, DOC, XLS, PPT — tối đa 10 MB)",
    attachmentCount: "{{count}} / {{max}}",
    attachmentSizeKb: "{{size}} KB",
    deleteAttachment: "Xoá tệp đính kèm",
    selectLabTest: "Chọn tiêu chuẩn kiểm nghiệm",
    labTestHint: "Tiêu chuẩn kiểm nghiệm yêu cầu cho mẫu này.",
    orderRemarks: "Ghi chú đơn hàng",
    printDevSheet: "In phiếu phát triển mẫu",
    devSheetTitle: "Phiếu phát triển mẫu",
    skippedExisting: "Bỏ qua {{count}} mã đã có trong danh mục: {{codes}}.",
    skippedIncomplete: "Bỏ qua {{count}} dòng thiếu mô tả hoặc loại: {{codes}}.",
    addToProductsFailed: "Không đẩy được các dòng này lên danh mục.",
    addToProducts: "Thêm vào dữ liệu sản phẩm",
    addedToProducts: "Đã thêm {{count}} sản phẩm vào danh mục.",
    alreadyInProducts: "Mã sản phẩm này đã có trong danh mục.",
    confirmDeleteOrder: "Xoá đơn hàng mẫu này? Bản ghi sẽ được lưu trữ và có thể khôi phục sau.",
    confirmDeleteCard: "Xoá thẻ mẫu này? Bản ghi sẽ được lưu trữ và có thể khôi phục sau.",
    errorSaveOrder: "Không thể lưu đơn hàng mẫu.",
    errorSaveCard: "Không thể lưu thẻ mẫu.",
    loadingOrder: "Đang tải đơn hàng mẫu…",
    productNoRequired: "Mã sản phẩm là bắt buộc.",
    typeRequired: "Loại là bắt buộc.",
    descriptionRequired: "Mô tả là bắt buộc.",
    document: "Đơn hàng mẫu",
    orderInfo: "Thông tin đơn hàng",
    supplierInfo: "Thông tin nhà cung cấp",
    orderDetails: "Chi tiết đơn hàng",
    contactPhone: "Điện thoại liên hệ",
    autoNumberHint: "Số sẽ được cấp khi lưu",
    supplierRequired: "Bắt buộc chọn nhà cung cấp.",
    itemsRequired: "Cần ít nhất một sản phẩm.",
    deliveryDateRequired: "Bắt buộc nhập ngày giao.",
    teamRequired: "Bắt buộc nhập bộ phận.",
    duplicateProductNo: "Mã sản phẩm này đã có trong đơn.",
    changeStatus: "Đổi trạng thái",
    deleteOrder: "Xoá đơn hàng mẫu",
    deleteCard: "Xoá thẻ mẫu",
    openAttachment: "Mở tệp đính kèm",
    uploadInProgress: "Chờ tải tệp lên xong rồi hãy lưu.",
    unsavedUploadsDescription: "Đơn hàng mẫu này có thay đổi chưa lưu, gồm cả tệp bạn đã tải lên. Nếu rời đi bây giờ, chúng sẽ bị mất.",
    loadingCard: "Đang tải thẻ mẫu…",
  },
  suppliers: {
    classification: "Khu vực",
    classificationHint: "Đội dùng nhà cung cấp này. Cùng một xưởng mà hai đội cùng mua thì mỗi đội giữ một hồ sơ riêng.",
    classificationChoose: "Chọn đội",
    classificationLocked: "Tài khoản của bạn chỉ làm việc với một khu vực nên không đổi được khu vực của nhà cung cấp.",
    unclassified: "Chưa phân loại",
    unclassifiedHint: "Chưa phân loại: cả hai đội đều thấy nhà cung cấp này cho tới khi chọn đội.",
    sectionAccess: "Quyền xem",
    accessHint: "Ai phụ trách nhà cung cấp này, và có giới hạn người được xem không.",
    followers: "Người theo dõi",
    followerAdd: "Thêm người theo dõi…",
    followersHint: "Nhân viên phụ trách nhà cung cấp này. Nhà cung cấp thường: cả đội vẫn thấy như cũ.",
    followersPrivateHint: "Nhà cung cấp riêng tư: chỉ quản trị viên và những người này thấy hồ sơ. Cũng chọn được ở Cài đặt → Người dùng → Phân quyền — cùng một danh sách.",
    followersNone: "Chưa có người theo dõi.",
    adminOnly: "Chỉ quản trị viên đổi được người theo dõi và nhà cung cấp riêng tư.",
    private: "Nhà cung cấp riêng tư",
    privateHint: "Chỉ quản trị viên và người theo dõi thấy hồ sơ, người liên hệ và giá vốn trên sản phẩm. Người khác vẫn thấy đơn mua, phiếu nhập, công nợ của nhà cung cấp này nhưng tên hiện là \"Nhà cung cấp nội bộ\" và không sửa được.",
    privateBadge: "Riêng tư",
    contactPrivate: "Chỉ quản trị viên xem",
    contactPrivateToggle: "Chỉ quản trị viên xem · người liên hệ {{n}}",
    vietnam: "Việt Nam",
    china: "Trung Quốc",
    portalLoginId: "Mã đăng nhập cổng NCC",
    portalLoginHint: "Mã này đưa cho nhà cung cấp: nó là tên đăng nhập, không phải bí mật; mật khẩu mới là thứ chứng minh danh tính. Không phân biệt hoa thường.",
    portalLoginGenerate: "Sinh mã",
    portalSection: "Cổng nhà cung cấp",
    portalIntro: "Nhà cung cấp đăng nhập bằng mã dưới đây và mật khẩu do bạn đặt tại đây. Tài khoản, mật khẩu và việc khoá/mở đều quản lý ở chỗ này.",
    portalAfterSave: "Lưu nhà cung cấp trước, rồi mở cổng ngay trên trang chỉnh sửa.",
    portalNoAccount: "Chưa mở cổng",
    portalStatusActive: "Đang mở",
    portalStatusDisabled: "Đang khoá",
    portalPassword: "Mật khẩu ban đầu",
    portalNewPassword: "Mật khẩu mới",
    portalPasswordConfirm: "Nhập lại mật khẩu",
    portalPasswordHint: "Ít nhất 8 ký tự. Đưa cho nhà cung cấp cùng với mã; họ phải đổi ngay lần đầu đăng nhập. Hệ thống không hiển thị lại mật khẩu.",
    portalOpen: "Mở cổng",
    portalOpened: "Đã mở cổng. Gửi mã và mật khẩu cho nhà cung cấp.",
    portalSaveLoginId: "Lưu mã",
    portalLoginIdSaved: "Đã đổi mã đăng nhập. Mã cũ không dùng được nữa.",
    portalMustChange: "Còn mật khẩu ban đầu: nhà cung cấp chưa đăng nhập và tự đổi.",
    portalPasswordChanged: "Nhà cung cấp đã tự đổi mật khẩu.",
    portalLastLogin: "Đăng nhập gần nhất: {{when}}",
    portalNeverLoggedIn: "Chưa đăng nhập lần nào.",
    portalResetPassword: "Đặt lại mật khẩu",
    portalResetDone: "Đã đặt lại mật khẩu. Nhà cung cấp sẽ phải đổi lại khi đăng nhập.",
    portalDisable: "Tạm khoá cổng",
    portalEnable: "Mở lại cổng",
    portalDisabled: "Đã khoá. Nhà cung cấp không đăng nhập được cho tới khi mở lại.",
    portalEnabled: "Đã mở lại cổng.",
    portalError: "Không thao tác được với tài khoản cổng.",
    companyContact: "Liên hệ công ty",
    editSupplier: "Chỉnh sửa nhà cung cấp",
    editNamed: "Chỉnh sửa nhà cung cấp: {{name}}",
    backToList: "Về danh sách nhà cung cấp",
    required: "Bắt buộc",
    title: "Nhà cung cấp",
    subtitle: "Dữ liệu gốc · nhà cung cấp & liên hệ",
    company: "Công ty",
    address: "Địa chỉ",
    phone: "Điện thoại",
    email: "Email",
    contacts: "Liên hệ",
    contactCount: "Số người liên hệ",
    moreContacts: "+{{count}} người nữa",
    newSupplier: "Nhà cung cấp mới",
    addContact: "Thêm liên hệ",
    contactName: "Tên liên hệ",
    contactCard: "Liên hệ {{n}}",
    specialization: "Chuyên môn",
    confirmDelete: "Xóa nhà cung cấp này? Sẽ được lưu trữ và có thể khôi phục sau.",
    loading: "Đang tải nhà cung cấp…",
    errorLoad: "Không thể tải danh sách nhà cung cấp.",
    errorSave: "Không thể lưu nhà cung cấp.",
    phone1: "Điện thoại 1",
    phone2: "Điện thoại 2",
    wechat: "WeChat ID",
    selectSpecialization: "Chọn chuyên môn",
    openSupplier: "Xem chi tiết nhà cung cấp",
    notFound: "Không tìm thấy nhà cung cấp.",
    errorDelete: "Không thể xóa nhà cung cấp này.",
    sectionCompany: "Công ty",
    companyHint: "Tên, địa chỉ, điện thoại và email in trên chứng từ mua hàng.",
    contactsCountHint: "{{count}}/{{max}} liên hệ · mỗi liên hệ phải có tên",
    saveHint: "Hàng liên hệ để trống hoàn toàn sẽ được bỏ khi lưu.",
    sideShow: "Hiện cột phụ",
    sideHide: "Ẩn cột phụ",
    sideColumns: "Điện thoại 2, WeChat ID",
    sideLocked: "Có người liên hệ đang dùng cột phụ nên cột phụ luôn hiện.",
    noContacts: "Nhà cung cấp này chưa có liên hệ.",
    viewProducts: "Xem sản phẩm",
    documents: "Chứng từ gần đây",
    documentsHint: "5 chứng từ mới nhất mỗi loại. Bấm Xem tất cả để mở danh sách đã lọc theo nhà cung cấp này.",
    contactsCount: "Liên hệ · {{count}}",
  },
  pi: {
    title: "Hóa đơn chiếu lệ (PI)",
    subtitle: "Chứng từ bán hàng gốc · sổ thanh toán",
    piNo: "Số PI",
    date: "Ngày",
    billTo: "Bên mua",
    poNo: "PO khách hàng",
    total: "Tổng",
    paid: "Đã trả",
    balance: "Còn lại",
    status: "Trạng thái",
    respBy: "Phụ trách",
    billToContact: "Bên mua / Liên hệ",
    notifyParty: "Bên nhận thông báo / Liên hệ",
    consignee: "Bên nhận hàng / Liên hệ",
    paymentCompany: "Công ty thanh toán",
    invoiceStatus: "Hóa đơn",
    notInvoiced: "Chưa lập hóa đơn",
    newPi: "PI mới",
    lineItems: "Dòng hàng",
    receivableTitle: "Đã trả cho từng hóa đơn",
    stillOwed: "Còn nợ",
    unapplied: "Đã thu nhưng chưa trừ cho hóa đơn nào",
    payments: "Thanh toán",
    item: "Mặt hàng",
    description: "Mô tả",
    qty: "Số lượng",
    exwTag: "EXW",
    exwUsedOnPrint: "Dòng này in ra theo giá EXW.",
    unitPrice: "Đơn giá",
    amount: "Thành tiền",
    noPayments: "Chưa ghi nhận thanh toán.",
    recordPayment: "Ghi nhận thanh toán",
    convertInvoice: "Tạo hóa đơn",
    createPacking: "Tạo phiếu đóng gói",
    createPo: "Tạo đơn mua hàng",
    document: "Hóa đơn chiếu lệ",
    invoiced: "Đã lập hóa đơn",
    delivery: "Giao hàng",
    shipping: "Vận chuyển",
    method: "Phương thức",
    subtotal: "Cộng tiền hàng",
    linesCount: "{{count}} dòng",
    errorLoad: "Không thể tải hóa đơn chiếu lệ này.",
    errorList: "Không thể tải danh sách hóa đơn chiếu lệ.",
    errorCreateInvoice: "Không thể tạo hóa đơn.",
    errorRecordPayment: "Không thể ghi nhận thanh toán.",
    validAmount: "Vui lòng nhập số tiền hợp lệ.",
    adminOnly: "Chỉ quản trị viên",
    adminOnlyHint: "Chỉ tài khoản quản trị viên thấy hóa đơn chiếu lệ này và mọi chứng từ phát sinh từ nó. Đánh dấu rồi thì không gỡ được.",
    adminOnlyAdminsOnly: "Chỉ quản trị viên được đánh dấu hóa đơn chiếu lệ là \"Chỉ quản trị viên\".",
    amendReason: "Lý do sửa hóa đơn chiếu lệ đã xuất hóa đơn",
    amendReasonHint: "Hóa đơn chiếu lệ này đã có hóa đơn. Sửa được, nhưng phải ghi lý do (ít nhất 5 ký tự) và lý do được lưu vào lịch sử chứng từ. Sửa xong, vào hóa đơn chọn lại hóa đơn chiếu lệ này để lấy giá mới — số hóa đơn giữ nguyên. Nếu đã có phiếu giao hàng thì không sửa được nữa.",
    confirmDelete: "Xóa PI {{number}}? Bản ghi sẽ được lưu trữ.",
    errorSave: "Không thể lưu hóa đơn chiếu lệ.",
    openBalance: "Dư nợ còn lại",
    contactPerson: "Người liên hệ",
    billToContactPerson: "Bên mua (người liên hệ)",
    notifyPartyCustomer: "Bên nhận thông báo",
    notifyPartyContactPerson: "Bên nhận thông báo (người liên hệ)",
    consigneeCustomer: "Bên nhận hàng",
    consigneeContactPerson: "Bên nhận hàng (người liên hệ)",
    shippingMarks: "Ký mã hiệu",
    customerDept: "Bộ phận khách hàng",
    portOfLoading: "Cảng xếp hàng",
    countryOfOrigin: "Nước xuất xứ",
    dnNo: "Số phiếu giao hàng",
    currency: "Tiền tệ",
    upcharge: "Phụ thu",
    discountPct: "Chiết khấu (%)",
    unknownCustomer: "(khách không còn trong danh sách)",
    selectCustomer: "Chọn khách hàng",
    selectContact: "Chọn người liên hệ",
    selectPaymentCompany: "Chọn công ty thanh toán",
    paymentCompanyMissing: "Chưa chọn công ty thu tiền — bản in sẽ không có thông tin chuyển khoản.",
    selectShippingMark: "Chọn ký mã hiệu",
    selectRespBy: "Chọn người phụ trách",
    noRespByOptions: "Không tải được danh sách nhân viên — gõ tên người phụ trách.",
    respByFromStaff: "Nhân viên đang hoạt động được lập / sửa PI và thấy được công ty của khách. Thêm người, khoá tài khoản hay đổi quyền ở Quản lý người dùng là danh sách đổi theo.",
    respByKept: "{{name}} (đã lưu trên PI)",
    termsAutofilled: "Tự điền từ điều khoản thanh toán của khách hàng (bên mua)",
    duplicatePo: "PO khách hàng \"{{po}}\" đã được dùng ở PI {{piNo}}.",
    addProducts: "Thêm sản phẩm",
    searchProducts: "Tìm sản phẩm theo mã",
    addToInvoice: "Thêm vào PI",
    paymentNote: "Ghi chú",
  },
  analytics: {
    noData: "Không có dữ liệu trong kỳ này.",
    region: "Đội",
    regionHint: "Xem riêng doanh số của từng đội.",
    orders: "Số đơn",
    summary: "Tổng quan",
    count: "Số đếm",
    dimension: "Chiều phân tích",
    avgOrderValue: "Giá trị đơn TB",
    totalQuantity: "Tổng số lượng",
    byRespBy: "Doanh thu theo người phụ trách",
    byProductType: "Doanh thu theo nhóm hàng",
    subtitle: "Doanh số theo sản phẩm, khách hàng và tháng",
    totalBilled: "Tổng đã lập PI",
    productsSold: "Sản phẩm đã bán",
    activeCustomers: "Khách hàng đang giao dịch",
    topProductsRevenue: "Sản phẩm hàng đầu · doanh thu",
    topCustomersRevenue: "Khách hàng hàng đầu · doanh thu",
    revenueByMonth: "Doanh thu theo tháng",
    errorLoad: "Không thể tải dữ liệu phân tích.",
  },
  insight: {
    from: "Từ ngày",
    to: "Đến ngày",
    reset: "Đặt lại",
    defaultPeriod: "Mặc định: {{from}} – {{to}}",
    presetDay: "Ngày gần nhất",
    presetWeek: "Tuần gần nhất",
    presetMonth: "Tháng gần nhất",
    presetsLabel: "Kỳ nhanh",
    presetHint: "Kỳ trượt kết thúc hôm nay (giờ Việt Nam): ngày gần nhất = hôm qua và hôm nay, tuần gần nhất = lùi 7 ngày, tháng gần nhất = từ cùng ngày tháng trước. Ngày điền sẵn vào ô nên thấy rõ đang tính kỳ nào.",
    rangeReversed: "Ngày bắt đầu sau ngày kết thúc",
  },
  profit: {
    subtitle: "Doanh thu PI so với giá vốn · lợi nhuận gộp",
    revenue: "Doanh thu",
    cost: "Giá vốn",
    costIncomplete: "Thiếu giá vốn",
    costIncompleteHint: "Có ít nhất một dòng không có giá mua lẫn giá vốn niêm yết nên bị tính bằng 0 — lãi hiện ra cao hơn thực tế.",
    costIncompleteNotice: "{{count}} PI có dòng chưa ghi giá vốn. Phần đó tính bằng 0, nên lãi ở trên đang cao hơn thực tế.",
    totalQuantity: "{{count}} sản phẩm đã đặt",
    costFromPo: "{{withPo}}/{{total}} PI lấy giá mua thật từ đơn mua hàng",
    grossMargin: "Lợi nhuận gộp",
    marginPercent: "Biên lợi nhuận %",
    margin: "Lợi nhuận",
    errorLoad: "Không thể tải tổng hợp lợi nhuận. Cần quyền quản trị viên hoặc quản lý.",
  },
  invoices: {
    subtitle: "Phát hành tương ứng 1:1 từ hóa đơn chiếu lệ",
    invoiceNo: "Số hóa đơn",
    document: "Hóa đơn",
    errorLoad: "Không thể tải danh sách hóa đơn.",
    notFound: "Không tìm thấy hóa đơn.",
    fromPiSummary: "{{customer}} · từ PI {{pi}}",
    title: "Hóa đơn",
    newInvoice: "Hóa đơn mới",
    piNo: "Số PI",
    selectPi: "Chọn hóa đơn chiếu lệ",
    noAvailablePi: "Không còn PI nào chưa lập hóa đơn.",
    piOption: "PI {{piNo}} · {{customer}} · {{currency}} {{amount}}",
    errorCreate: "Không thể tạo hóa đơn.",
    errorSave: "Không thể lưu hóa đơn.",
    copiedFromPi: "Sao chép từ hóa đơn chiếu lệ",
    editInvoice: "Sửa hóa đơn",
    editHint: "Chỉ ngày, người liên hệ bên mua và số PO khách hàng được phép khác PI. Các trường còn lại đều được chép sang.",
    changePi: "Đổi PI nguồn",
    changePiWarning: "Đổi PI sẽ chép lại toàn bộ phần đầu và tất cả dòng hàng từ PI mới.",
    searchPiHint: "Tìm theo số PI hoặc PO khách hàng",
    numberAssigned: "Cấp khi lưu",
    confirmDelete: "Xóa hóa đơn {{number}}? Bản ghi sẽ được lưu trữ.",
    errorDelete: "Không thể xóa hóa đơn.",
  },
  purchaseOrders: {
    subtitle: "Đơn hàng nhà cung cấp · tạo từ PI theo giá vốn",
    alreadyOnOrder: "Đã có trên đơn này — chọn lại sẽ tạo thêm một dòng nữa.",
    alreadyOnOrderShort: "· đã có",
    orderNo: "Số PO",
    errorLoad: "Không thể tải danh sách đơn mua hàng.",
    expectedDelivery: "Dự kiến giao",
    new: "Đơn mua hàng mới",
    document: "Đơn mua hàng",
    orderDate: "Ngày đặt hàng",
    actualDelivery: "Giao thực tế",
    paymentTerms: "Điều khoản thanh toán",
    shippingMethod: "Phương thức vận chuyển",
    supplierSection: "Thông tin nhà cung cấp",
    orderDetails: "Chi tiết đơn hàng",
    selectContact: "Chọn người liên hệ",
    contactPerson: "Người liên hệ",
    linkPi: "Liên kết hoá đơn chiếu lệ",
    linkPiHint: "Chọn một PI để tự động điền nhà cung cấp và dòng hàng theo giá vốn.",
    piAlreadyLinked: "PI {{number}} đã được liên kết với đơn mua hàng {{po}}.",
    taxPercent: "Thuế (%)",
    tax: "Tiền thuế",
    addProduct: "Thêm sản phẩm",
    noItems: "Chưa có dòng hàng nào.",
    selectSupplierFirst: "Hãy chọn nhà cung cấp trước khi thêm sản phẩm.",
    supplierMismatch: "{{product}} không thuộc {{supplier}}.",
    supplierChangeClears: "Đổi nhà cung cấp sẽ xoá các dòng hàng hiện tại.",
    supplierRequired: "Cần chọn nhà cung cấp.",
    itemsRequired: "Cần ít nhất một dòng hàng.",
    expectedRequired: "Cần nhập ngày giao dự kiến.",
    loading: "Đang tải đơn mua hàng…",
    errorSave: "Không thể lưu đơn mua hàng.",
    confirmDelete: "Xoá đơn mua hàng {{number}}? Bản ghi sẽ được lưu trữ.",
    notFound: "Không tìm thấy đơn mua hàng.",
    numberAssigned: "Cấp khi lưu",
    numberYearHint: "Năm trong số PO lấy theo ngày phát hành, không theo ngày đặt hàng.",
    searchPi: "Tìm PI theo số PI hoặc PO khách hàng",
    clearPi: "Bỏ chọn PI",
    linkedPi: "PI đã liên kết",
    createFromPi: "Tạo đơn mua hàng từ PI này",
    createFromPiHint: "Các dòng hàng được nhóm theo nhà cung cấp; mỗi nhà cung cấp sẽ có một đơn mua hàng, tính theo giá vốn.",
    createdCount: "Đã tạo {{count}} đơn mua hàng.",
    supplierReadOnly: "Lấy từ hồ sơ nhà cung cấp",
    invalidTax: "Nhập thuế suất từ 0 đến 100.",
    errorDelete: "Không thể xóa đơn mua hàng.",
  },
  packingLists: {
    subtitle: "Thông tin thùng · tạo từ PI",
    listNo: "Số phiếu đóng gói",
    errorLoad: "Không thể tải danh sách phiếu đóng gói.",
    piInvoice: "PI / Số hóa đơn",
    shippingMode: "Phương thức vận chuyển",
    weightKgs: "Trọng lượng N/G (kg)",
    newPackingList: "Phiếu đóng gói mới",
    attention: "Người nhận (Attn)",
    shippingMarks: "Ký mã hiệu",
    selectPi: "Hóa đơn chiếu lệ",
    selectPiHint: "Tìm theo số PI, số hóa đơn, bên mua hoặc nơi nhận",
    piLocked: "Không thể đổi PI sau khi đã tạo phiếu đóng gói.",
    availableItems: "Hàng còn lại để đóng gói",
    originalQty: "Số lượng ban đầu",
    remainingQty: "Số lượng còn lại",
    depleted: "Đã đóng đủ",
    ctnNo: "Số thùng",
    shipTo: "Nơi giao hàng",
    newCtn: "Thêm thùng",
    removeCtn: "Xóa thùng",
    addToCtn: "Thêm vào thùng",
    emptyCtn: "Thùng trống — thêm hàng ở trên",
    netWeight: "Trọng lượng tịnh (kg)",
    grossWeight: "Trọng lượng cả bì (kg)",
    measurement: "Kích thước (cm)",
    itemNo: "Mã hàng",
    subRef: "Mã phụ",
    customerPo: "PO khách hàng",
    errorNoCtn: "Hãy tạo ít nhất một thùng trước khi lưu.",
    errorEmptyCtn: "Có {{count}} thùng trống. Hãy thêm hàng hoặc xóa thùng.",
    errorOverQty: "Số lượng còn lại tối đa là {{max}}.",
    errorSave: "Không thể lưu phiếu đóng gói.",
    invoiceNo: "Số hóa đơn",
    selectCtn: "Chọn thùng",
    available: "Còn lại",
    packedQty: "Đã đóng",
    noCtns: "Chưa có thùng nào.",
    noPiSelected: "Hãy chọn hóa đơn chiếu lệ trước.",
    errorLoadPi: "Không thể tải hóa đơn chiếu lệ.",
    confirmDelete: "Xoá phiếu đóng gói {{number}}? Bản ghi sẽ được lưu trữ.",
    empty: "Chưa có phiếu đóng gói nào.",
  },
  deliveryNotes: {
    sourceLockedHint: "Chứng từ nguồn được cố định sau khi tạo phiếu — đổi nguồn sẽ xoá sạch số lượng đã giao. Chọn nhầm nguồn thì xoá phiếu này và tạo lại từ chứng từ đúng.",
    shipTo: "Nơi giao hàng",
    subtitle: "Lô hàng · từ phiếu đóng gói hoặc hóa đơn",
    noteNo: "Số phiếu giao hàng",
    billTo: "Bên nhận hóa đơn",
    errorLoad: "Không thể tải danh sách phiếu giao hàng.",
    deliveryDate: "Ngày giao",
    newDeliveryNote: "Phiếu giao hàng mới",
    deliveryStatus: "Trạng thái giao hàng",
    refType: "Loại chứng từ nguồn",
    fromPacking: "Từ phiếu đóng gói",
    fromInvoice: "Từ hóa đơn",
    selectReference: "Chứng từ nguồn",
    deliveryMode: "Phương thức giao",
    deliveryModeHint: "vd: xe tải, xe van, chuyển phát",
    vehicleNo: "Số xe",
    driverName: "Tên tài xế",
    driverPhone: "Điện thoại tài xế",
    itemNo: "Mã hàng",
    ctnNo: "Số thùng",
    subRef: "Mã phụ",
    orderedQty: "Số lượng đặt",
    deliveredQty: "Số lượng đã giao",
    lineRemarks: "Ghi chú dòng",
    errorNoReference: "Hãy chọn phiếu đóng gói hoặc hóa đơn trước.",
    errorSave: "Không thể lưu phiếu giao hàng.",
    confirmDelivery: "Xác nhận số lượng đã giao",
    created: "Đã tạo phiếu giao hàng {{number}}.",
    changeStatus: "Đổi trạng thái giao hàng",
    totalOrdered: "Tổng số lượng đặt",
    totalDelivered: "Tổng số lượng đã giao",
    deliveredCap: "Số lượng đã giao không được vượt quá số lượng đặt.",
    noItems: "Phiếu giao hàng này không có dòng nào.",
    errorCreate: "Không thể tạo phiếu giao hàng.",
    confirmDelete: "Xoá phiếu giao hàng {{number}}? Bản ghi sẽ được lưu trữ.",
    empty: "Chưa có phiếu giao hàng nào.",
  },
  statement: {
    sheetSummary: "tong-hop",
    sheetDetails: "chi-tiet",
    sheetAging: "tuoi-no",
    agingAll: "Tuổi nợ · toàn bộ khách đang xem",
    expandAll: "Mở tất cả",
    collapseAll: "Thu gọn tất cả",
    overdueDays: "quá hạn {{count}} ngày",
    bucket: "Nhóm tuổi nợ",
    exportSheets: "Xuất Excel (3 bảng)",
    totalBilled: "Đã xuất",
    totalPaid: "Đã thu",
    recovered: "đã thu hồi",
    outstanding: "Còn lại",
    overdue: "Quá hạn",
    overdueCount: "{{count}} chứng từ",
    billedShort: "Xuất",
    paidShort: "Thu",
    subtitle: "Công nợ phải thu · tuổi nợ theo khách hàng",
    allCustomers: "Tất cả khách hàng",
    noBalances: "Không có công nợ chưa thanh toán",
    allSettled: "Tất cả hóa đơn đã được thanh toán.",
    errorLoad: "Không thể tải bảng kê công nợ.",
  },
  users: {
    subtitle: "Tài khoản & vai trò · phân quyền bắt buộc tại máy chủ",
    newUser: "Người dùng mới",
    createUser: "Tạo người dùng",
    user: "Người dùng",
    errorCreate: "Không thể tạo người dùng.",
    errorLoad: "Không thể tải danh sách người dùng. Cần quyền quản trị viên.",
    editUser: "Sửa người dùng",
    changeRole: "Đổi vai trò",
    confirmPassword: "Xác nhận mật khẩu",
    passwordMismatch: "Mật khẩu không khớp.",
    you: "bạn",
    resetPassword: "Đặt lại mật khẩu",
    disableUser: "Vô hiệu hóa tài khoản",
    enableUser: "Kích hoạt tài khoản",
    lastAdminProtected: "Không thể hạ quyền quản trị viên cuối cùng.",
    selfDowngradeBlocked: "Bạn không thể tự hạ quyền quản trị của mình. Hãy nhờ quản trị viên khác.",
    confirmRoleChange: "Gỡ quyền quản trị của {{email}}?",
    errorUpdate: "Không thể cập nhật người dùng.",
  },
  settings: {
    sectionsLabel: "Các nhóm cài đặt",
    catalogTab: "Danh mục",
    catalogTabHint: "Từ điển sản phẩm",
    companyTab: "Công ty",
    companyTabHint: "Nhận diện và liên hệ",
    outputTab: "Đầu ra",
    outputTabHint: "Máy in và tài liệu",
    masterDataEyebrow: "Dữ liệu gốc",
    organisationEyebrow: "Tổ chức",
    outputEyebrow: "Đầu ra",
    catalogOptions: "Tùy chọn danh mục",
    productTypes: "Loại sản phẩm",
    productTypesDescription: "Quản lý danh sách Loại trong cửa sổ Tạo và Sửa sản phẩm. Thứ tự tại đây cũng là thứ tự hiển thị trong biểu mẫu. Tên tiếng Hoa (không bắt buộc) hiện dưới tên tiếng Anh trên các màn sản phẩm.",
    productTypePlaceholder: "Ví dụ: Nút bấm kim loại",
    productUnits: "Đơn vị sản phẩm",
    productUnitsDescription: "Quản lý danh sách Đơn vị trong cửa sổ Tạo và Sửa sản phẩm. Các đơn vị đang dùng được tự động đưa vào danh sách.",
    productUnitPlaceholder: "Ví dụ: gross",
    configuredCount: "Đã cấu hình {{count}}",
    addOption: "Thêm giá trị",
    optionLabelZh: "Tên tiếng Hoa",
    optionExists: "Giá trị này đã tồn tại.",
    moveUp: "Di chuyển lên",
    moveDown: "Di chuyển xuống",
    removeOption: "Xóa giá trị",
    minimumOneOption: "Cần giữ lại ít nhất một giá trị",
    companyInformation: "Thông tin công ty",
    companyName: "Tên công ty",
    labelPrinter: "Máy in nhãn nhiệt (CT321D)",
    labelPreset: "Khổ tem có sẵn",
    labelCustom: "Khổ tự nhập…",
    labelSizeInvalid: "Khổ tem không hợp lệ ({{field}}). Dùng 20–100 mm.",
    widthMm: "Chiều rộng (mm)",
    heightMm: "Chiều cao (mm)",
    labelRotate: "Xoay nội dung 90° khi in",
    errorLoad: "Không thể tải cài đặt.",
    errorSave: "Không thể lưu cài đặt.",
    paymentTerms: "Điều khoản thanh toán",
    paymentTermsDescription: "Điều khiển danh sách Điều khoản thanh toán trên khách hàng, đơn mua hàng và hoá đơn chiếu lệ. Thứ tự tại đây là thứ tự hiển thị trong biểu mẫu.",
    paymentTermsPlaceholder: "Ví dụ: After Statement 30 Days",
    shippingMethods: "Phương thức vận chuyển",
    shippingMethodsDescription: "Điều khiển danh sách Phương thức vận chuyển trên đơn mua hàng.",
    poPriorities: "Mức ưu tiên đơn mua hàng",
    poPrioritiesDescription: "Điều khiển danh sách Mức ưu tiên trên đơn mua hàng.",
    paymentCompanies: "Công ty thu tiền",
    paymentCompaniesDescription: "Thông tin người thụ hưởng và tài khoản ngân hàng, in trên mọi Proforma Invoice và Invoice.",
    addCompany: "Thêm công ty",
    defaultCompany: "Mặc định",
    companyLogo: "Logo in trên chứng từ",
    noLogo: "Chưa có logo — bản in dùng logo Hisense mặc định",
    uploadLogo: "Tải logo lên",
    beneficiary: "Người thụ hưởng",
    beneficiaryBank: "Ngân hàng thụ hưởng",
    bankAddress: "Địa chỉ ngân hàng",
    swiftCode: "Mã SWIFT",
    accountNumberUsd: "Số tài khoản USD",
    accountNumberHkd: "Số tài khoản HKD",
    accountNumberRmb: "Số tài khoản RMB",
    setAsDefaultCompany: "Đặt làm công ty mặc định",
    lastUpdated: "Cập nhật lần cuối {{when}} bởi {{who}}",
    counters: "Bộ đếm số chứng từ",
    countersDescription: "Chỉ xem: số kế tiếp mà mỗi dãy sẽ cấp.",
    defaults: "Giá trị mặc định cho bản ghi mới",
    defaultsDescription: "Áp khi tạo sản phẩm mới; bản ghi đã có không bị đụng tới.",
    defaultCurrency: "Đơn vị tiền mặc định",
    defaultProductUnit: "Đơn vị sản phẩm mặc định",
    shippingMarks: "Ký mã hiệu",
    shippingMarksDescription: "Các ký mã hiệu gợi ý sẵn trên form Proforma Invoice.",
    shippingMarkPlaceholder: "ví dụ: N/M",
    weightUnits: "Đơn vị khối lượng",
    weightUnitsDescription: "Đơn vị hiện cạnh ô khối lượng /100 sản phẩm.",
    weightUnitPlaceholder: "ví dụ: kg",
    currencies: "Danh sách tiền tệ",
    currencyPlaceholder: "VD: USD",
    shippingMethodPlaceholder: "VD: Sea Freight",
    poPriorityPlaceholder: "VD: Urgent",
    quotationPreparedByPlaceholder: "VD: Louis Chen",
    currenciesDescription: "Điều khiển danh sách Tiền tệ trên mọi chứng từ bán hàng và mua hàng.",
    quotationPreparedBy: "Tuỳ chọn \"Người lập\" báo giá",
    quotationPreparedByDescription: "Điều khiển danh sách Người lập trên báo giá.",
    labTestStandards: "Tiêu chuẩn kiểm nghiệm",
    labTestStandardsDescription: "Điều khiển danh sách Yêu cầu kiểm nghiệm trong màn hình tạo/sửa đơn hàng mẫu. Thứ tự ở đây là thứ tự hiển thị trong biểu mẫu.",
    supplierSpecializations: "Chuyên môn nhà cung cấp",
    supplierSpecializationsDescription: "Điều khiển danh sách Chuyên môn trên liên hệ nhà cung cấp. Thứ tự tại đây là thứ tự hiển thị trong biểu mẫu.",
    supplierSpecializationPlaceholder: "Ví dụ: Plastic Stopper",
  },
  archive: {
    searchPlaceholder: "Tìm số chứng từ, PO khách, người xoá…",
    allTypes: "Tất cả loại",
    documentNo: "Số chứng từ",
    party: "Đối tác",
    viewSnapshot: "Xem dữ liệu gốc",
    notRestorable: "Chỉ lưu vết",
    notRestorableHint: "Bảng này xoá vĩnh viễn; kho lưu trữ giữ một bản để truy vết, nhưng không dựng lại bản ghi được.",
    confirmRestore: "Khôi phục bản ghi này? Nó sẽ xuất hiện lại trong danh sách và trong báo cáo.",
    snapshotTitle: "Dữ liệu gốc của bản ghi đã xoá",
    snapshotRedacted: "Giá vốn và thông tin nhà cung cấp đã được che theo quyền của bạn.",
    errorRestore: "Không khôi phục được bản ghi này.",
    restoreProductTitle: "Khôi phục với mã hoặc Sub Ref mới",
    restoreProductHint: "Nhập mã hoặc Sub Ref khác cho sản phẩm đã xoá rồi khôi phục. Sản phẩm đang dùng cặp cũ giữ nguyên.",
    openConflictingProduct: "Mở sản phẩm đang dùng cặp này (thẻ mới)",
    subtitle: "Kho lưu trữ kiểm toán · khôi phục bản ghi đã xóa",
    empty: "Kho lưu trữ đang trống",
    emptyHint: "Các bản ghi đã xóa sẽ xuất hiện tại đây để khôi phục.",
    errorLoad: "Không thể tải kho lưu trữ. Cần quyền quản trị viên.",
  },
  resourceTypes: {
    piAttachments: "Tệp bằng chứng đặt hàng (PI)",
    customerRequirements: "Yêu cầu sản phẩm của khách",
    customerRequirementPhotos: "Ảnh yêu cầu của khách",
    routings: "Quy trình công đoạn",
    customers: "Khách hàng",
    suppliers: "Nhà cung cấp",
    products: "Sản phẩm",
    proformaInvoices: "Hóa đơn chiếu lệ",
    invoices: "Hóa đơn",
    quotations: "Báo giá",
    purchaseOrders: "Đơn mua hàng",
    packingLists: "Phiếu đóng gói",
    deliveryNotes: "Phiếu giao hàng",
    sampleOrders: "Đơn hàng mẫu",
    sampleCards: "Thẻ mẫu",
    boms: "Định mức nguyên vật liệu",
    salesOrders: "Đơn bán hàng",
    purchaseRequisitions: "Phiếu đề nghị mua",
    warehouses: "Kho",
    warehouseBins: "Vị trí kho",
    stockMoves: "Phiếu nhập xuất",
    productionResources: "Nguồn lực sản xuất",
    workOrders: "Lệnh sản xuất",
    inspections: "Phiếu kiểm tra",
    glAccounts: "Tài khoản sổ cái",
    journalEntries: "Bút toán",
    serviceTickets: "Phiếu hỗ trợ",
    qualitySpecs: "Tiêu chuẩn chất lượng",
    mrpRuns: "Kịch bản MRP",
    unitProfiles: "Hồ sơ đơn vị",
    piPayments: "Thanh toán PI",
    salesOpportunities: "Cơ hội bán hàng",
    serviceCases: "Hồ sơ hậu mãi",
    sourcingCases: "Yêu cầu báo giá (RFQ)",
    subcontractOrders: "Lệnh gia công",
  },
  comingSoon: {
    title: "Đang phát triển",
    description: "Tính năng này đang được xây dựng và sẽ sớm ra mắt. Cảm ơn bạn đã kiên nhẫn chờ đợi.",
    backToOverview: "Quay về Tổng quan",
  },
  status: {
    paid: "Đã thanh toán",
    partial: "Thanh toán một phần",
    unpaid: "Chưa thanh toán",
    approved: "Đã duyệt",
    pending: "Chờ xử lý",
    underReview: "Đang xem xét",
    rejected: "Từ chối",
    draft: "Nháp",
    active: "Hoạt động",
    inactive: "Ngừng hoạt động",
    disabled: "Đã vô hiệu hóa",
    obsolete: "Ngừng sử dụng",
    confirmed: "Đã xác nhận",
    sent: "Đã gửi",
    delivered: "Đã giao",
    partiallyDelivered: "Đã giao một phần",
    inTransit: "Đang vận chuyển",
    received: "Đã nhận",
    testing: "Đang kiểm tra",
    completed: "Hoàn tất",
    inProduction: "Đang sản xuất",
    shipped: "Đã giao",
    closed: "Đã đóng",
    cancelled: "Đã hủy",
    ordered: "Đã đặt hàng",
    in: "Nhập",
    out: "Xuất",
    transfer: "Điều chuyển",
    adjust: "Điều chỉnh",
    planned: "Đã lên kế hoạch",
    released: "Đã phát hành",
    inProgress: "Đang thực hiện",
    done: "Hoàn tất",
    pass: "Đạt",
    fail: "Không đạt",
    incoming: "Đầu vào",
    inProcess: "Trong quá trình",
    final: "Cuối cùng",
    asset: "Tài sản",
    liability: "Nợ phải trả",
    equity: "Vốn chủ sở hữu",
    revenue: "Doanh thu",
    expense: "Chi phí",
    low: "Thấp",
    medium: "Trung bình",
    high: "Cao",
    urgent: "Khẩn cấp",
    open: "Đang mở",
    resolved: "Đã giải quyết",
    current: "Hiện tại",
    paymentProgress: "{{status}} — {{percent}}%",
  },
  roles: {
    admin: "Quản trị viên",
    manager: "Quản lý",
    accountant: "Kế toán",
    viewer: "Người xem",
  },
  account: {
    security: "Bảo mật",
    changePassword: "Đổi mật khẩu",
    currentPassword: "Mật khẩu hiện tại",
    newPassword: "Mật khẩu mới",
    confirmPassword: "Nhập lại mật khẩu mới",
    passwordHint: "Tối thiểu 8 ký tự.",
    passwordMismatch: "Hai lần nhập mật khẩu mới không khớp.",
    passwordChanged: "Đã đổi mật khẩu. Mật khẩu mới áp dụng từ lần đăng nhập sau.",
    errorChangePassword: "Không đổi được mật khẩu.",
    // Chân thanh bên (19/09/2026): tài khoản chọn từng màn hình không hiện vai trò gốc — "Người xem" dưới tên nhân viên mua hàng là sai.
    customAccess: "Phân quyền riêng",
  },
  label: {
    printer: "Máy in tem",
    print: "In tem",
    count: "Số tem in",
    qty: "Số lượng mẫu",
    qtyHint: "Tuỳ chọn — ghi đè số lượng in trên tem.",
    dialogHint: "Bấm In sẽ mở hộp thoại in của máy tính — chọn máy in tem trong đó. Máy tem phải đã được cài trong máy tính; chưa cài thì nó không có trong danh sách và tem sẽ in ra máy in giấy.",
    sizeInUse: "Khổ tem {{w}} × {{h}} mm, lấy từ Cài đặt.",
    error: {
      badSize: "Khổ tem trong Cài đặt không hợp lệ ({{field}}). Sửa lại trước khi in.",
    },
  },
  errors: {
    supplierRegion: "Tài khoản này chỉ làm việc với nhà cung cấp thuộc khu vực của mình. Hãy nhờ quản trị viên tạo hoặc chuyển nhà cung cấp này.",
    followerInvalid: "Người theo đơn phải là nhân viên đang hoạt động (không phải tài khoản đã khoá hay tài khoản cổng nhà cung cấp).",
    followerRegion: "Người theo đơn này không thấy được khách của khu vực này. Đổi khu vực của người đó trong Phân quyền, hoặc chọn người khác.",
    privateAdminOnly: "Chỉ quản trị viên đổi được thiết lập riêng tư và danh sách người được xem.",
    privateSupplier: "Chứng từ này dùng một nhà cung cấp riêng tư bạn không được xem. Chỉ quản trị viên và người theo dõi nhà cung cấp đó sửa được.",
    unauthorized: "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
    readOnly: "Bạn chỉ có quyền xem bản ghi này — các ô bị khoá chứ không phải lỗi.",
    forbidden: "Bạn không có quyền thực hiện thao tác này.",
    validation: "Một số thông tin chưa hợp lệ. Vui lòng kiểm tra biểu mẫu và thử lại.",
    notFound: "Bản ghi này không còn tồn tại hoặc không khả dụng.",
    emailTaken: "Địa chỉ email này đã được sử dụng.",
    invoiceExists: "Hóa đơn chiếu lệ này đã có hóa đơn.",
    currencyMismatch: "Đơn vị tiền tệ của giá phải khớp với sản phẩm.",
    notRestorable: "Không thể khôi phục bản ghi lưu trữ này.",
    noFile: "Vui lòng chọn ảnh để tải lên.",
    badImageType: "Chỉ hỗ trợ ảnh PNG, JPEG, WEBP hoặc GIF.",
    imageTooLarge: "Ảnh phải có dung lượng không quá 5 MB.",
    companyTaken: "Đã tồn tại khách hàng với tên công ty này.",
    supplierCompanyTaken: "Đã có nhà cung cấp tên này trong cùng khu vực (hoặc một nhà cung cấp chưa phân loại cùng tên).",
    portalLoginIdTaken: "Mã đăng nhập này đã có nhà cung cấp khác dùng. Mỗi nhà cung cấp phải có mã riêng.",
    portalLoginIdFormat: "Mã đăng nhập dài 3–40 ký tự: chữ, số, gạch ngang hoặc gạch dưới; không khoảng trắng, không dấu @.",
    portalAccountExists: "Nhà cung cấp này đã có tài khoản cổng.",
    portalAccountMissing: "Nhà cung cấp này chưa có tài khoản cổng.",
    originalRowMissing: "Bản ghi gốc không còn trong hệ thống, chỉ còn bản lưu. Không khôi phục được — bản lưu vẫn được giữ nguyên.",
    customerRequired: "Phải chọn khách hàng (Bill To).",
    customerRegion: "Tài khoản này chỉ làm việc với khách thuộc khu vực của mình. Hãy nhờ quản trị viên tạo hoặc chuyển khách này.",
    paymentCompanyRequired: "Phải chọn công ty thu tiền.",
    itemsRequired: "Phải có ít nhất một dòng hàng.",
    forbiddenTitle: "Bạn không có quyền vào mục này",
    forbiddenBody: "Tài khoản của bạn không được cấp quyền xem trang này. Nếu cần, hãy liên hệ quản trị viên.",
    forbiddenGoHome: "Về trang chính",
    productCodeExhausted: "Không cấp được mã sản phẩm chưa dùng. Vui lòng nhập thủ công.",
    piAlreadyLinked: "Hóa đơn chiếu lệ này đã được liên kết với một đơn mua hàng.",
    supplierMismatch: "Có dòng hàng không thuộc nhà cung cấp đã chọn.",
    duplicateCtnNo: "Số thùng không được trùng nhau.",
    overPacked: "Số lượng đóng gói vượt quá dòng hàng trên hóa đơn chiếu lệ.",
    unknownLine: "Có dòng không thuộc phiếu giao hàng này.",
  },
  print: {
    code: "Mã",
    description: "Mô tả",
    colorSize: "Màu / Kích cỡ",
    qty: "Số lượng",
    unitPrice: "Đơn giá",
    amount: "Thành tiền",
    subtotal: "Cộng tiền hàng",
    upcharge: "Phụ thu",
    less: "Chiết khấu ({{pct}}%)",
    grandTotal: "TỔNG CỘNG",
    total: "Tổng cộng",
    remarks: "Ghi chú",
    generated: "Tạo lúc {{date}}",
  },
  erpResource: {
    errorLoad: "Không thể tải phân hệ này.",
    errorCreate: "Không thể tạo bản ghi.",
    subtitles: {
      boms: "Định mức vật tư · cấu trúc nhiều cấp",
      salesOrders: "Đơn bán hàng xuyên suốt · kiểm soát tín dụng",
      requisitions: "Yêu cầu mua hàng · nhu cầu MRP",
      warehouses: "Địa điểm lưu kho",
      stockMoves: "Nhập / xuất / điều chuyển / điều chỉnh",
      workOrders: "Lệnh sản xuất · sản lượng",
      inspections: "QC đầu vào / trong quá trình / cuối cùng",
      glAccounts: "Hệ thống tài khoản kế toán",
      journalEntries: "Bút toán · tích hợp nghiệp vụ và tài chính",
      serviceTickets: "Dịch vụ sau bán hàng & RMA",
    },
    fields: {
      product: "Sản phẩm",
      productCode: "Mã sản phẩm",
      version: "Phiên bản",
      status: "Trạng thái",
      soNo: "Số SO",
      orderDate: "Ngày đặt hàng",
      total: "Tổng",
      customer: "Khách hàng",
      remarks: "Ghi chú",
      prNo: "Số PR",
      neededBy: "Ngày cần",
      code: "Mã",
      name: "Tên",
      location: "Vị trí",
      moveNo: "Số phiếu kho",
      type: "Loại",
      qty: "Số lượng",
      when: "Thời điểm",
      quantity: "Số lượng",
      reference: "Tham chiếu",
      woNo: "Số WO",
      planned: "Kế hoạch",
      produced: "Đã sản xuất",
      description: "Mô tả",
      plannedQty: "Số lượng kế hoạch",
      dueDate: "Ngày đến hạn",
      qcNo: "Số QC",
      result: "Kết quả",
      rejected: "Bị loại",
      referencePoWo: "Tham chiếu (PO/WO)",
      qtyInspected: "Số lượng đã kiểm",
      qtyRejected: "Số lượng bị loại",
      notes: "Ghi chú",
      accountType: "Loại",
      jeNo: "Số JE",
      date: "Ngày",
      memo: "Diễn giải",
      debit: "Nợ",
      credit: "Có",
      amount: "Số tiền",
      debitAccount: "Tài khoản nợ",
      creditAccount: "Tài khoản có",
      sourceRef: "Tham chiếu nguồn",
      ticket: "Phiếu",
      subject: "Tiêu đề",
      priority: "Ưu tiên",
      supplier: "Nhà cung cấp",
    },
  },
};
